import { SupportedTickers } from './entities';
import { DateTime, DurationInput } from 'luxon';

export class StockReportsStore {
  private date?: DateTime;
  private supportedTickers?: SupportedTickers;

  constructor() {
    this.date = DateTime.now();
    this.supportedTickers = undefined;

    const tickersFromLocalStorage = this.getSupportedTickersLocalStorage();
    if (tickersFromLocalStorage) {
      this.supportedTickers = tickersFromLocalStorage;
    }
  }

  public shouldFetchSupportedTickers = async (lastUpdatedDuration: DurationInput = { hour: 1 }): Promise<boolean> => {
    const timeAgo = DateTime.now().minus(lastUpdatedDuration);

    if (this.supportedTickers && this.supportedTickers.last_updated) {
      const lastUpdated = this.parseDate(this.supportedTickers);
      if (lastUpdated && lastUpdated < timeAgo) return true;
      if (this.supportedTickers?.stored_date) {
        return this.supportedTickers?.stored_date < timeAgo;
      }
    }
    const supportedTickers = await this.getSupportedTickers(lastUpdatedDuration);
    if (!supportedTickers) {
      return true;
    }
    return false;
  };

  public getSupportedTickers = async (
    lastUpdatedDuration: DurationInput = { hour: 1 },
  ): Promise<SupportedTickers | undefined> => {
    const locallyStoredSupportedTickers =
      this.supportedTickers || this.getSupportedTickersLocalStorage(lastUpdatedDuration);
    if (locallyStoredSupportedTickers) return locallyStoredSupportedTickers;
    const staticSupportedTickers = await this.getSupportedTickersStatic();
    if (staticSupportedTickers) return staticSupportedTickers;
    return undefined;
  };

  public updateSupportedTickers = (supportedTickers: SupportedTickers): SupportedTickers => {
    this.supportedTickers = supportedTickers;
    supportedTickers.stored_date = this.date;
    if (typeof localStorage !== 'undefined' && supportedTickers.tickers) {
      localStorage.setItem('supportedTickers', JSON.stringify(supportedTickers));
    }
    return supportedTickers;
  };

  public getSupportedTickersStatic = async (): Promise<SupportedTickers | undefined> => {
    const staticSupportedTickers = await import('./staticTickers').then(module => module.staticSupportedTickers);
    return staticSupportedTickers.data;
  };

  private getSupportedTickersLocalStorage = (
    lastUpdatedDuration: DurationInput = { hour: 1 },
  ): SupportedTickers | undefined => {
    if (typeof localStorage !== 'undefined') {
      const timeAgo = DateTime.now().minus(lastUpdatedDuration);
      const supportedTickers = localStorage.getItem('supportedTickers');
      const parsedSupportedTickers: SupportedTickers | undefined = supportedTickers && JSON.parse(supportedTickers);
      if (!parsedSupportedTickers) return undefined;
      const lastUpdated = this.parseDate(parsedSupportedTickers);
      if (lastUpdated && lastUpdated > timeAgo) return parsedSupportedTickers;
    }
    return undefined;
  };

  private parseDate = (supportedTickers: SupportedTickers | SupportedTickers | undefined): DateTime | null => {
    if (!supportedTickers) return null;
    const formattedDate = DateTime.fromJSDate(new Date(supportedTickers.last_updated?.replace('at', '')));
    return formattedDate;
  };
}

// public getTransformedSupportedTickers = async (): Promise<SupportedTickers | undefined> => {
//   const apiUrl = 'https://api.benzinga.com/api/v1/report/supported-tickers-v2';

//   try {
//     const response = await fetch(apiUrl);
//     const data = await response.json();

//     if (!data.ok) {
//       throw new Error('API request failed');
//     }

//     const inputData = data.data;

//     const transformedData = {
//       last_updated: inputData.last_updated,
//       tickers: Object.values(inputData.tickers).map((ticker: any) => ticker.symbol),
//     };

//     return transformedData;
//   } catch (error) {
//     console.error('Error transforming tickers:', error);
//     throw error;
//   }
// };
